import { render } from "./Header.vue?vue&type=template&id=e9152fda&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=e9152fda&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/fast-blockchains-dashboard/fast-blockchains-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9152fda"]])

export default __exports__